export const mockBlogPosts = [
  {
    id: '1',
    title: 'How Smart Metering Reduces Operational Costs by 30%',
    excerpt: 'Discover how automated meter reading and leak detection technologies are transforming utility management across the Baltics.',
    content: 'Full article content here...',
    image: 'https://images.pexels.com/photos/839443/pexels-photo-839443.jpeg',
    date: '2025-01-15',
    author: 'Andrius Petrauskas',
    category: 'Smart Metering'
  },
  {
    id: '2',
    title: 'The Future of Parking: AI-Powered Flow Management',
    excerpt: 'Learn how Viziosense computer vision technology is revolutionizing parking operations in smart cities.',
    content: 'Full article content here...',
    image: 'https://images.pexels.com/photos/839443/pexels-photo-839443.jpeg',
    date: '2025-01-10',
    author: 'Laura Kalniņa',
    category: 'Smart Cities'
  },
  {
    id: '3',
    title: 'Indoor Air Quality: A Silent Productivity Killer',
    excerpt: 'Why monitoring CO2 and VOC levels can improve workplace productivity by up to 15%.',
    content: 'Full article content here...',
    image: 'https://images.pexels.com/photos/839443/pexels-photo-839443.jpeg',
    date: '2025-01-05',
    author: 'Kristjan Tamm',
    category: 'Indoor Air Quality'
  }
];